function TemplateDataGridCriteria(searchPhrase, sortColumns, pageNumber, rowsPerSheet, excludedIds, searchProperties,
                                  clinicId) {
    this.searchPhrase = searchPhrase;
    this.sortColumns = sortColumns;
    this.pageNumber = pageNumber;
    this.rowsPerSheet = rowsPerSheet;
    this.excludedIds = excludedIds;
    this.searchProperties = searchProperties;

    this.clinicId = clinicId;

    if (_.isUndefined(this.rowsPerSheet)) {
        this.rowsPerSheet = 20;
    }
    if (_.isUndefined(this.pageNumber)) {
        this.pageNumber = 0;
    }

    var _typeContext = {
        sortColumns: EsDataGridSort
    };

    this._getType = function(property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    };

    var _mappingContext = {
    };

    this._getMapping = function (property) {
        if (_mappingContext[property]) {
            return _mappingContext[property];
        }
        else {
            return undefined;
        }
    };
}
